import { SplitFlags } from '../../../hooks/featureFlags';

export interface SurveyConfig {
  title: string;
  startDate: string;
  dueDate: string;
  link: string;
  splitFlag?: SplitFlags;
}

const COACH_SATISFACTION_SURVEY: SurveyConfig = {
  title: 'Exos Satisfaction Survey',
  startDate: '2026-04-09',
  dueDate: '2026-04-27',
  link: 'https://exos.sjc1.qualtrics.com/jfe/form/SV_b2bibQha4vSOu7c',
};

export const ALL_SURVEYS = [COACH_SATISFACTION_SURVEY];
